/**
 * Body editor for the qtable step: just the container name input.
 */
import React from "react"
import { QueryBuilderStore } from "stores/queryBuilderStore"
import { QTableStep } from "types/queryBuilder.types"
import { StepBodyProps } from "./stepBodyProps"

export interface QTableStepBodyProps extends StepBodyProps<QTableStep> {
  renameStep: QueryBuilderStore["renameTransformStep"]
}

const QTableStepBody: React.FC<QTableStepBodyProps> = ({
  step,
  renameStep,
}) => (
  <input
    className="qc-recodes__name qc-mono"
    type="text"
    value={step.name}
    onChange={(e) => renameStep(step.id, e.target.value)}
    placeholder="Container name (use // for nesting)"
    aria-label="Container name"
  />
)

export default QTableStepBody
